import MarkdownLinkRegex from '../regex/MarkdownLinkRegex';

function removeMarkdownLinks(string: string): string {
  return string.replace(MarkdownLinkRegex, '$1');
}

export default removeMarkdownLinks;
